import { Interactions } from "one-state-interactions/src/Intercations";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Pending Referal component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
     let result: any[] = [];

     let interactionresult: any = {
         callerinteractiondata: result,
         error: undefined
 
     }
    
    if (response && (response.status >= 400 || response.type == "error")) {
        interactionresult.error = response;
    }
    else if (response && response.length > 0) {
      
        if(response && response.length> 0) {
            response.map ((interactioninfo: any)=> {
               
            if(interactioninfo?.result && interactioninfo.result.length > 0) {
                interactioninfo.result.map((interactiondata: any)=>{
                  
                    result.push(interactiondata)
                })
            }
            })
        }
    }
    interactionresult.callerinteractiondata = result;
    return interactionresult;
}